import React from "react";

const NoteCard = ({ topic, description, image }) => {
  return (
    <div className="card note-card mb-5">
      <div className="card-body">
        <div className="d-flex">
          {/* Image Column */}
          <div>
            <img
              src={image}
              alt={topic}
              width={20}
              height={20}
              className="me-2"
            />
          </div>

          {/* Topic Column */}
          <div className="mx-3">
            <h2
              className="fs-5 fs-sm-4 mb-2 mb-sm-0"
              style={{ whiteSpace: "nowrap" }}
            >
              {topic}
            </h2>
          </div>

          {/* Description Column */}
          <div className="col-lg-9">
            <p className="card-text" style={{ color: "#666666" }}>
              {description}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoteCard;
